import { API_BASE_URL } from '../constants/suggestions';

const parseResponse = async (response) => {
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || `HTTP error ${response.status}`);
  }
  return response;
};

export const fetchDocumentList = async (token) => {
  const response = await fetch(`${API_BASE_URL}/documents`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const parsed = await parseResponse(response);
  return parsed.json();
};

export const fetchDocumentFile = async (documentPath, token) => {
  // Use query parameter for path to support nested folders
  const url = `${API_BASE_URL}/documents/fetch?path=${encodeURIComponent(documentPath)}`;
  
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const parsed = await parseResponse(response);
  const contentType = parsed.headers.get('content-type') || '';
  const buffer = await parsed.arrayBuffer();
  return { buffer, contentType };
};

export const deleteDocument = async (inode, token) => {
  const response = await fetch(`${API_BASE_URL}/documents/delete`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ inode }),
  });

  const parsed = await parseResponse(response);
  return parsed.json();
};

export const deleteDocumentsBulk = async (inodes, token) => {
  if (!Array.isArray(inodes) || inodes.length === 0) {
    throw new Error('At least one document is required to delete.');
  }

  const response = await fetch(`${API_BASE_URL}/documents/delete/bulk`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ inodes }),
  });

  const parsed = await parseResponse(response);
  return parsed.json();
};

export const clearAllDocuments = async (token) => {
  const response = await fetch(`${API_BASE_URL}/documents/delete/all`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  const parsed = await parseResponse(response);
  return parsed.json();
};
